import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap'

import { SignOutLink } from './userManagement/SignOut'
import { NavigationWrapper, FillerDiv } from './StyledComponents/Fillers'
import * as routes from '../constants/routes'
import { auth } from '../firebase'

const brandIcon = require('../assets/images/brandIcon.svg')

const NavigationAuth = () =>
    (
        <Nav className="ml-auto" navbar>
            <NavItem>
                <Link className="nav-link" to={routes.DASHBOARD}>Dashboard</Link>
            </NavItem>
            <NavItem>
                <Link className="nav-link" to={routes.PLANTS}>Pflanzen</Link>
            </NavItem>
            <NavItem>
                <Link className="nav-link" to={routes.DEVICES}>Geräte</Link>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                    Profile
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem>
                        <Link className="nav-link" to={routes.ACCOUNT}>Account</Link>
                    </DropdownItem>
                    <DropdownItem>
                        <Link className="nav-link" to={routes.SETTINGS}>Einstellungen</Link>
                    </DropdownItem>
                    <DropdownItem onClick={auth.doSignOut}>
                        <SignOutLink>Logout</SignOutLink>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </Nav>
    )

const NavigationNonAuthNew = () =>
    (
        <Nav className="ml-auto" navbar>
            <NavItem>
                <Link className="nav-link" to={routes.SIGN_IN}>Login</Link>
            </NavItem>
            <NavItem>
                <Link className="nav-link" to={routes.PLANTS}>Pflanzen</Link>
            </NavItem>
            <NavItem>
                <Link className="nav-link" to={routes.SIGN_UP}>Registrieren</Link>
            </NavItem>
        </Nav>
    )

class Navigation extends React.Component {
    constructor(props) {
        super(props)

        this.toggle = this.toggle.bind(this)
        this.state = {
            isOpen: false,
        }
    }

    componentDidMount() {
        this.props.history.listen((location, action) => {
            if (this.state.isOpen) {
                this.toggle()
            }
        })
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const { authUser } = this.props
        return (
            <NavigationWrapper>
                <Navbar color="dark" dark fixed="top" expand="md">
                    <FillerDiv className="container">
                        <NavbarBrand href="/"><img src={brandIcon} width="30" alt="FlowerAI smart garden assistant" /></NavbarBrand>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            { authUser
                                ? <NavigationAuth />
                                : <NavigationNonAuthNew />
                            }
                        </Collapse>
                    </FillerDiv>
                </Navbar>
            </NavigationWrapper>
        )
    }
}

const mapStateToProps = state => ({
    authUser: state.sessionState.authUser,
})

export default compose(
    withRouter,
    connect(mapStateToProps),
)(Navigation)



// WEBPACK FOOTER //
// ./src/components/Navigation.js